module.exports = __webpack_public_path__ + "img/组 2241@2x.9c3c7b63.png";